/* eslint import/prefer-default-export: off */
import '../stylesheets/application.scss';

import Sittercity from './sittercity';
import App from '../apps/App.vue';
import { setupApollo } from '../lib/apollo_setup';

import router from '../router';
import store from '../store';

// we should break out apollo initialization into its own file
// so when we need to import the reference, the source file makes sense and not some random application.ts file.
export const apolloProvider = setupApollo();

document.addEventListener('DOMContentLoaded', () => {
  const appNode = document.getElementById('app-rerouted');

  if (appNode === null) {
    console.log('Continuing to entrypoints');
  } else {
    new Sittercity({
      router,
      store,
      apolloProvider,
      name: 'Sittercity',
      propsData: {
        skipSegmentPageEvent: true, // afterEach hook handles Segment in SPA mode (see router/index.ts)
      },
      render(createElement) {
        return createElement(App);
      },
    }).$mount('#app-rerouted');
  }
});
